import {
  Card,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import EditSquareIcon from "../../../ui/icons/EditSquareIcon";
import DynamicSvgIcon from "../../../ui/icons/DynamicSvgIcon";
import { t } from "i18next";

interface CategoryItemProps {
  category: Category;
  divider: boolean;
  onEdit: (category: any) => void;
}

const CategoryItem = (props: CategoryItemProps): JSX.Element => {
    const {category, divider, onEdit} = props;
    const isRoot = category.isRoot;

    return (
        <>
        <ListItem
            divider={divider}
            secondaryAction={
            <IconButton
                edge="end"
                aria-label={t('edit_category', { ns: 'categories', name: category.name })}
                onClick={() => onEdit(category)}
            >
                <EditSquareIcon style={{ fontSize: 16 }} />
            </IconButton>
            }
            sx={{
            pl: isRoot || category.type === 'income' ? 1 : 2,
            mt: isRoot ? 2 : 0,
            }}
        >
            <ListItemAvatar sx={{ minWidth: 36 }}>
            <Card
                elevation={isRoot ? 4 : 0}
                sx={{ borderRadius: '50%', overflow: 'hidden', display: 'inline-block' }}
            >
                <DynamicSvgIcon
                    svgUrl={category.icon}
                    color={category.iconColor}
                    backgroundColor={category.backgroundColor}
                    size={30}
                    iconSize={20}
                />
            </Card>
            </ListItemAvatar>
            <ListItemText
            primary={category.name}
            secondary={category.type}
            />
        </ListItem>
        </>
    );
};

export default CategoryItem;
